import axios from 'axios';
import { getAuth } from 'firebase/auth';
import getBackendUrl from '../utils/api';

// Configuração global do axios
axios.defaults.baseURL = getBackendUrl();
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Interceptor para adicionar o token de autenticação
axios.interceptors.request.use(
  async (config) => {
    // Multipart/FormData: o default 'application/json' quebra o boundary do multipart
    // e o Flask recebe corpo vazio (request.files fica vazio). Deixar o browser definir
    // Content-Type com boundary.
    if (config.data instanceof FormData) {
      const h = config.headers;
      // Axios 1.x (AxiosHeaders): `false` remove o header e permite o boundary do multipart
      if (h && typeof h.set === 'function') {
        h.set('Content-Type', false);
      } else if (h) {
        delete h['Content-Type'];
        delete h['content-type'];
      }
    }
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (currentUser) {
      const idToken = await currentUser.getIdToken();
      config.headers.Authorization = `Bearer ${idToken}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratamento de erros
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // O servidor respondeu com um status de erro
      console.error('Erro na resposta:', error.response.data);
      
      // Se for erro de autenticação, redirecionar para login
      if (error.response.status === 401) {
        // Evita redirecionar se o usuário já estiver em rotas públicas (ex.: /register ou /login)
        if (typeof window !== 'undefined') {
          const pathname = window.location.pathname;
          const isPublicPath = pathname.startsWith('/login') || pathname.startsWith('/register');
          if (!isPublicPath) {
            window.location.href = '/login';
          }
        }
      }
    } else if (error.request) {
      // A requisição foi feita mas não houve resposta
      // ✅ CORREÇÃO: Não logar se foi cancelada (readyState: 0 ou AbortError)
      const isCanceled = error.name === 'AbortError' || 
                        error.name === 'CanceledError' ||
                        (error.request && error.request.readyState === 0);
      
      if (!isCanceled) {
        console.error('Erro na requisição:', error.request);
      }
    } else {
      // Erro ao configurar a requisição
      // ✅ CORREÇÃO: Não logar se foi cancelada
      const isCanceled = error.name === 'AbortError' || error.name === 'CanceledError';
      if (!isCanceled) {
        console.error('Erro:', error.message);
      }
    }
    
    return Promise.reject(error);
  }
);

export default axios; 